<template>
  <span>{{text}}</span>
</template>
<script>
export default { props: ['text'] };
</script>



// WEBPACK FOOTER //
// src/projections/default-content.vue?2983b4c4